import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ConfigApi } from "../../config-api";
import { ApiCallingService } from "../../services/api-calling.service";

@Component({
  selector: "app-vending-donation-details",
  templateUrl: "./vending-donation-details.component.html",
  styleUrls: ["./vending-donation-details.component.css"],
})
export class DonationDetailComponent implements OnInit {
  donationId: string;
  details: any;

  constructor(
    private apiCallingService: ApiCallingService,
    private route: ActivatedRoute
  ) {
    this.donationId = this.route.snapshot.paramMap.get("id") || "";
  }

  ngOnInit(): void {
    this.getDonationDetails();
  }

  getDonationDetails() {
    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.VENDING_DONATION_TRANSACTION.DETAILS +
          "/" +
          this.donationId
      )
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.details = res.data;
        }
      });
  }
}
